"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Resume extends React.Component {
    // todo: DB experience, skills
    render() {
        return (React.createElement("section", { className: "pt-page pt-page-2 pt-page-current pt-page-rotateCubeRightIn", "data-id": "resume" },
            React.createElement("div", { className: "section-title-block" },
                React.createElement("h2", { className: "section-title" }, "Resume"),
                React.createElement("h5", { className: "section-description" }, "8 Years of Experience")),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-6 col-md-4 subpage-block" },
                    React.createElement("div", { className: "block-title" },
                        React.createElement("h3", null, "Experience")),
                    React.createElement("div", { className: "timeline" },
                        React.createElement("div", { className: "timeline-event te-primary" },
                            React.createElement("h5", { className: "event-date" }, "OCT 2012 - Current"),
                            React.createElement("h4", { className: "event-name" }, "Software developer"),
                            React.createElement("span", { className: "event-description" }, "Techno"),
                            React.createElement("p", null, "Developing server applications for payment processing")))),
                React.createElement("div", { className: "col-sm-6 col-md-4 subpage-block" },
                    React.createElement("div", { className: "block-title" },
                        React.createElement("h3", null, "Backend")),
                    React.createElement("div", { className: "skills-info" },
                        React.createElement("h4", null, ".NET Core 2.0+"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-1" })),
                        React.createElement("h4", null, "Node.JS"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-6" })),
                        React.createElement("h4", null, "Docker"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-5" })),
                        React.createElement("h4", null, "CI/CD: TeamCity, GitLab"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-7" }))),
                    React.createElement("div", { className: "block-title" },
                        React.createElement("h3", null, "Frontend")),
                    React.createElement("div", { className: "skills-info" },
                        React.createElement("h4", null, "React JS"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-4" })),
                        React.createElement("h4", null, "Redux"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-2" })),
                        React.createElement("h4", null, "Webpack"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-3" })))),
                React.createElement("div", { className: "col-sm-6 col-md-4 subpage-block" },
                    React.createElement("div", { className: "block-title" },
                        React.createElement("h3", null, "Database")),
                    React.createElement("div", { className: "skills-info" },
                        React.createElement("h4", null, "MySql"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-2" }))),
                    React.createElement("div", { className: "skills-info" },
                        React.createElement("h4", null, "Redis"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-2" }))),
                    React.createElement("div", { className: "skills-info" },
                        React.createElement("h4", null, "MongoDB"),
                        React.createElement("div", { className: "skill-container" },
                            React.createElement("div", { className: "skill-percentage skill-2" })))))));
    }
}
exports.default = Resume;
